import { Code, Smartphone, Database, Cog, Plug, Box, Palette, Headphones, Award, Users, Target, Clock } from 'lucide-react';
import React from 'react';

export const mockData = {
  contactEmail: 'contacto@codigoalamedida.com',
  heroImages: [
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkYXNoYm9hcmQlMjBtb2NrdXB8ZW58MHx8fHwxNzc5ODU0ODE2fDA&ixlib=rb-4.1.0&q=85',
    'https://i.pinimg.com/1200x/b7/8b/a3/b78ba3d56011cda6940469bf6487cd22.jpg',
    'https://images.unsplash.com/photo-1551721434-8b94ddff0e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxtb2JpbGUlMjBhcHAlMjBpbnRlcmZhY2V8ZW58MHx8fHwxNzc5ODU0ODE2fDA&ixlib=rb-4.1.0&q=85'
  ],
  
  services: [
    {
      icon: React.createElement(Code, { className: 'w-8 h-8' }),
      title: 'Desarrollo Web',
      description: 'Sitios web modernos, responsivos y optimizados para conversión y rendimiento.'
    },
    {
      icon: React.createElement(Smartphone, { className: 'w-8 h-8' }),
      title: 'Aplicaciones Móviles',
      description: 'Apps nativas y multiplataforma para iOS y Android con experiencia premium.'
    },
    {
      icon: React.createElement(Database, { className: 'w-8 h-8' }),
      title: 'Sistemas Empresariales',
      description: 'ERP, CRM y soluciones empresariales escalables y seguras.'
    },
    {
      icon: React.createElement(Cog, { className: 'w-8 h-8' }),
      title: 'Automatización de Procesos',
      description: 'Optimiza operaciones y reduce costos con automatización inteligente.'
    },
    {
      icon: React.createElement(Plug, { className: 'w-8 h-8' }),
      title: 'APIs e Integraciones',
      description: 'Conecta sistemas y plataformas con APIs robustas y seguras.'
    },
    {
      icon: React.createElement(Box, { className: 'w-8 h-8' }),
      title: 'Software a la Medida',
      description: 'Soluciones personalizadas que se adaptan perfectamente a tu negocio.'
    },
    {
      icon: React.createElement(Palette, { className: 'w-8 h-8' }),
      title: 'UI/UX Design',
      description: 'Diseños modernos, intuitivos y centrados en la experiencia del usuario.'
    },
    {
      icon: React.createElement(Headphones, { className: 'w-8 h-8' }),
      title: 'Soporte y Mantenimiento',
      description: 'Asistencia continua y actualizaciones para mantener tu software al día.'
    }
  ],

  stats: [
    {
      icon: React.createElement(Award, { className: 'w-8 h-8' }),
      value: '50+',
      label: 'Proyectos Completados'
    },
    {
      icon: React.createElement(Users, { className: 'w-8 h-8' }),
      value: '40+',
      label: 'Clientes Satisfechos'
    },
    {
      icon: React.createElement(Target, { className: 'w-8 h-8' }),
      value: '15+',
      label: 'Tecnologías Dominadas'
    },
    {
      icon: React.createElement(Clock, { className: 'w-8 h-8' }),
      value: '24/7',
      label: 'Soporte Continuo'
    }
  ],

  technologies: [
    'React', 'Next.js', 'Node.js', 'Flutter', 'Firebase', 'Python', 
    'Laravel', 'PostgreSQL', 'MongoDB', 'Docker', 'AWS', 'TailwindCSS',
    'TypeScript', 'GraphQL', 'Redis', 'Kubernetes'
  ],

  portfolio: [
    {
      title: 'App de Delivery',
      description: 'Plataforma completa de entrega con seguimiento en tiempo real y gestión de pedidos.',
      image: 'https://images.unsplash.com/photo-1659353740953-c93814e4a2a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxkZWxpdmVyeSUyMGFwcHxlbnwwfHx8fDE3Nzk4NTQ4NDV8MA&ixlib=rb-4.1.0&q=85',
      tags: ['React Native', 'Node.js', 'MongoDB']
    },
    {
      title: 'Sistema ERP',
      description: 'Solución empresarial integral para gestión de inventario, ventas y recursos humanos.',
      image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHNvZnR3YXJlfGVufDB8fHx8MTc3OTg1NDg1Mnww&ixlib=rb-4.1.0&q=85',
      tags: ['Laravel', 'Vue.js', 'PostgreSQL']
    },
    {
      title: 'Plataforma Ecommerce',
      description: 'Tienda online moderna con carrito, pagos seguros y panel administrativo completo.',
      image: 'https://images.unsplash.com/photo-1586880244406-556ebe35f282?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxlY29tbWVyY2V8ZW58MHx8fHwxNzc5ODU0ODQ1fDA&ixlib=rb-4.1.0&q=85',
      tags: ['Next.js', 'Stripe', 'Firebase']
    },
    {
      title: 'Dashboard Administrativo',
      description: 'Panel de control con analíticas avanzadas, reportes y visualización de datos en tiempo real.',
      image: 'https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxkYXNoYm9hcmR8ZW58MHx8fHwxNzc5ODU0ODQ1fDA&ixlib=rb-4.1.0&q=85',
      tags: ['React', 'D3.js', 'Node.js']
    },
    {
      title: 'App de Reservaciones',
      description: 'Sistema de reservas con calendario inteligente, notificaciones y gestión de clientes.',
      image: 'https://images.unsplash.com/photo-1772734645532-a200e06f105d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxib29raW5nJTIwYXBwfGVufDB8fHx8MTc3OTg1NDg1Mnww&ixlib=rb-4.1.0&q=85',
      tags: ['Flutter', 'Firebase', 'Python']
    }
  ],

  testimonials: [
    {
      name: 'Carlos Martínez',
      position: 'CEO, TechStart México',
      text: 'El equipo de Código a la Medida transformó completamente nuestra visión en una aplicación funcional y elegante. Su profesionalismo y atención al detalle son excepcionales.'
    },
    {
      name: 'Ana Rodríguez',
      position: 'Directora de Operaciones, LogiPro',
      text: 'Implementaron nuestro sistema ERP en tiempo récord. La automatización de procesos ha mejorado nuestra eficiencia en un 60%. Altamente recomendados.'
    },
    {
      name: 'Miguel Hernández',
      position: 'Fundador, DeliveryExpress',
      text: 'Desarrollaron nuestra app de delivery desde cero. El resultado superó nuestras expectativas. Ahora procesamos más de 500 pedidos diarios sin problemas.'
    }
  ]
};